import { permissionConfig } from '@/config/permissions';
import type { PlatformPermission } from '@/services/generated/model';

export type { PlatformPermission } from '@/services/generated/model';

export const platformPermissions = {
  aboutRead: 'platform.about.read',
  accountsRead: 'platform.accounts.read',
  accountsConnect: 'platform.accounts.connect',
  accountsUpdate: 'platform.accounts.update',
  announcementsBatch: 'platform.announcements.batch',
  announcementsCreate: 'platform.announcements.create',
  announcementsDelete: 'platform.announcements.delete',
  announcementsRead: 'platform.announcements.read',
  announcementsUpdate: 'platform.announcements.update',
  apiKeysRead: 'platform.apikeys.read',
  apiKeysCreate: 'platform.apikeys.create',
  apiKeysUpdate: 'platform.apikeys.update',
  apiKeysRevoke: 'platform.apikeys.revoke',
  backupRead: 'platform.backup.read',
  channelsRead: 'platform.channels.read',
  clustersRead: 'platform.clusters.read',
  dashboardRead: 'platform.dashboard.read',
  departmentsCreate: 'platform.departments.create',
  departmentsDelete: 'platform.departments.delete',
  departmentsRead: 'platform.departments.read',
  departmentsUpdate: 'platform.departments.update',
  dictionariesCreate: 'platform.dictionaries.create',
  dictionariesDelete: 'platform.dictionaries.delete',
  dictionariesRead: 'platform.dictionaries.read',
  dictionariesUpdate: 'platform.dictionaries.update',
  healthRead: 'platform.health.read',
  instancesRead: 'platform.instances.read',
  logsRead: 'platform.logs.read',
  modelsRead: 'platform.models.read',
  positionsCreate: 'platform.positions.create',
  positionsDelete: 'platform.positions.delete',
  positionsRead: 'platform.positions.read',
  positionsUpdate: 'platform.positions.update',
  quotasRead: 'platform.quotas.read',
  requestLogsRead: 'platform.requestlogs.read',
  rolesCreate: 'platform.roles.create',
  rolesDelete: 'platform.roles.delete',
  rolesRead: 'platform.roles.read',
  rolesUpdate: 'platform.roles.update',
  rolloutsRead: 'platform.rollouts.read',
  routingRead: 'platform.routing.read',
  serversRead: 'platform.servers.read',
  serversCreate: 'platform.servers.create',
  serversUpdate: 'platform.servers.update',
  settingsRead: 'platform.settings.read',
  settingsUpdate: 'platform.settings.update',
  usageRead: 'platform.usage.read',
  usersCreate: 'platform.users.create',
  usersDelete: 'platform.users.delete',
  usersRead: 'platform.users.read',
  usersUpdate: 'platform.users.update',
} as const satisfies Record<string, PlatformPermission>;

export const allPlatformPermissions = Object.values(platformPermissions);

export type PlatformPermissionSubject = {
  isSuperAdmin?: boolean;
  permissions?: readonly PlatformPermission[];
};

export function hasPlatformPermission(
  subject: PlatformPermissionSubject | null | undefined,
  permission?: PlatformPermission,
  enforcementEnabled = permissionConfig.enabled,
) {
  return (
    !enforcementEnabled ||
    !permission ||
    subject?.isSuperAdmin === true ||
    subject?.permissions?.includes(permission) === true
  );
}
